import { useState } from 'react';

const serviceCategories = [
  {
    icon: 'ri-flashlight-fill',
    color: '#FFD700',
    title: 'Installation & Upgrades',
    services: [
      { icon: 'ri-home-wifi-line', name: 'Electrical Installations' },
      { icon: 'ri-git-branch-line', name: 'Full & Partial Rewiring' },
      { icon: 'ri-dashboard-2-line', name: 'Consumer Unit Upgrades' },
      { icon: 'ri-lightbulb-flash-line', name: 'Lighting Installation' },
      { icon: 'ri-sun-line', name: 'LED Lighting Upgrades' },
      { icon: 'ri-plant-line', name: 'Outdoor & Garden Lighting' },
      { icon: 'ri-shield-flash-line', name: 'Security Lighting' },
      { icon: 'ri-plug-2-line', name: 'Socket & Switch Installation' },
      { icon: 'ri-charging-pile-2-line', name: 'EV Charger Installation' },
      { icon: 'ri-home-gear-line', name: 'Smart Home Installations' },
      { icon: 'ri-remote-control-line', name: 'Home Automation Systems' },
      { icon: 'ri-temp-hot-line', name: 'Heating Controls & Thermostats' },
      { icon: 'ri-drop-line', name: 'Electric Shower Installation' },
      { icon: 'ri-fridge-line', name: 'Kitchen Electrical Installations' },
    ],
  },
  {
    icon: 'ri-tools-fill',
    color: '#FF6B35',
    title: 'Repair & Maintenance',
    services: [
      { icon: 'ri-hammer-line', name: 'Electrical Repairs' },
      { icon: 'ri-search-eye-line', name: 'Fault Finding & Diagnostics' },
      { icon: 'ri-alert-line', name: 'Tripping Circuits' },
      { icon: 'ri-settings-3-line', name: 'Fuse Box Repairs' },
      { icon: 'ri-lightbulb-line', name: 'Lighting Repairs' },
      { icon: 'ri-plug-line', name: 'Socket & Switch Repairs' },
      { icon: 'ri-alarm-warning-line', name: 'Emergency Call-Outs' },
      { icon: 'ri-calendar-check-line', name: 'Electrical Maintenance Contracts' },
      { icon: 'ri-checkbox-circle-line', name: 'PAT Testing' },
      { icon: 'ri-cpu-line', name: 'Electrical Appliance Repairs' },
    ],
  },
  {
    icon: 'ri-shield-check-fill',
    color: '#00E5A0',
    title: 'Safety & Compliance',
    services: [
      { icon: 'ri-file-list-3-line', name: 'EICR Testing' },
      { icon: 'ri-home-2-line', name: 'Landlord Safety Certificates' },
      { icon: 'ri-building-line', name: 'Homebuyer Electrical Reports' },
      { icon: 'ri-alarm-line', name: 'Smoke & Heat Alarm Installation' },
      { icon: 'ri-fire-line', name: 'Fire Alarm Systems' },
      { icon: 'ri-shield-star-line', name: 'Surge Protection' },
      { icon: 'ri-earth-line', name: 'Earthing & Bonding' },
      { icon: 'ri-toggle-line', name: 'RCD Testing' },
    ],
  },
];

export default function Services() {
  const [activeCategory, setActiveCategory] = useState(0);

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-[#0D1F3C] to-[#0A1628] relative overflow-hidden">
      {/* Animated Streaks */}
      <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none">
        <div className="svc-streak svc-streak-1"></div>
        <div className="svc-streak svc-streak-2"></div>
        <div className="svc-streak svc-streak-3"></div>
        <div className="svc-streak svc-streak-4"></div>
      </div>

      {/* Glow orbs */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#FFD700]/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#FFD700]/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-[#FFD700]/15 border border-[#FFD700]/40 text-[#FFD700] px-5 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-flashlight-fill"></i>
            What We Do
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our <span className="text-[#FFD700] glow-text-sm">Services</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Comprehensive electrical solutions for homes &amp; businesses across Watford, Rickmansworth &amp; surrounding areas
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {serviceCategories.map((cat, i) => (
            <button
              key={i}
              onClick={() => setActiveCategory(i)}
              className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm transition-all duration-300 cursor-pointer whitespace-nowrap border-2 ${
                activeCategory === i
                  ? 'bg-[#FFD700] text-[#0A1628] border-[#FFD700] shadow-lg shadow-[#FFD700]/30 scale-105'
                  : 'bg-white/5 text-gray-300 border-white/10 hover:border-[#FFD700]/50 hover:text-[#FFD700]'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.title}
            </button>
          ))}
        </div>

        {/* Active Category Panel */}
        {serviceCategories.map((cat, catIdx) => (
          <div
            key={catIdx}
            className={`transition-all duration-500 ${activeCategory === catIdx ? 'block' : 'hidden'}`}
          >
            {/* Category Header */}
            <div className="flex items-center gap-3 mb-6 p-4 rounded-xl bg-white/5 border border-[#FFD700]/20 backdrop-blur-sm">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#FFD700]/20 border border-[#FFD700]/40 shrink-0">
                <i className={`${cat.icon} text-xl text-[#FFD700]`}></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">{cat.title}</h3>
                <p className="text-gray-400 text-xs mt-0.5">{cat.services.length} services — Watford, Rickmansworth &amp; beyond</p>
              </div>
              <div className="ml-auto hidden sm:flex items-center gap-2 bg-[#FFD700]/10 border border-[#FFD700]/30 rounded-full px-3 py-1.5">
                <i className="ri-map-pin-fill text-[#FFD700] text-xs"></i>
                <span className="text-[#FFD700] text-xs font-semibold whitespace-nowrap">Local &amp; Certified</span>
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-3">
              {cat.services.map((service, sIdx) => (
                <a
                  key={sIdx}
                  href="#contact"
                  className="group flex items-center gap-2 sm:gap-3 p-3 rounded-lg bg-white/5 border border-white/10 hover:border-[#FFD700] hover:bg-[#FFD700]/10 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#FFD700]/15 border border-[#FFD700]/30 group-hover:bg-[#FFD700] transition-all duration-300 shrink-0">
                    <i className={`${service.icon} text-sm text-[#FFD700] group-hover:text-[#0A1628] transition-colors duration-300`}></i>
                  </div>
                  <span className="text-gray-300 group-hover:text-white font-medium text-xs sm:text-sm leading-snug transition-colors duration-300 line-clamp-2">
                    {service.name}
                  </span>
                </a>
              ))}
            </div>
          </div>
        ))}

        {/* CTA */}
        <div className="text-center mt-14">
          <p className="text-gray-400 mb-5 text-base">Don't see what you need? We cover all electrical work.</p>
          <a
            href="#contact"
            className="inline-flex items-center bg-[#FFD700] text-[#0A1628] px-10 py-4 rounded-full font-bold text-base hover:bg-[#FFC700] transition-all duration-300 shadow-xl hover:shadow-[#FFD700]/40 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line mr-2"></i>
            Get a Free Quote Today
          </a>
        </div>
      </div>

      <style>{`
        @keyframes svc-streak {
          0% { transform: translateX(-100%) translateY(0) rotate(35deg); opacity: 0; }
          30% { opacity: 0.6; }
          100% { transform: translateX(200vw) translateY(80vh) rotate(35deg); opacity: 0; }
        }
        .svc-streak {
          position: absolute;
          width: 2px;
          height: 280px;
          background: linear-gradient(to bottom, transparent, #FFD700, transparent);
          animation: svc-streak linear infinite;
          box-shadow: 0 0 10px #FFD700;
        }
        .svc-streak-1 { left: 10%; top: 0; animation-duration: 5s; animation-delay: 0s; }
        .svc-streak-2 { left: 35%; top: 0; animation-duration: 6.5s; animation-delay: 2s; }
        .svc-streak-3 { left: 65%; top: 0; animation-duration: 5.8s; animation-delay: 1s; }
        .svc-streak-4 { left: 88%; top: 0; animation-duration: 7s; animation-delay: 3.5s; }
        .glow-text-sm {
          text-shadow: 0 0 15px rgba(255,215,0,0.5), 0 0 30px rgba(255,215,0,0.2);
        }
      `}</style>
    </section>
  );
}
